import * as React from 'react';
import TransparencyButton from './transparencyButton';
import { AdObj } from '../../../shared/types/ast';

export type Marking = 'partner' | 'sponsor';

type Props = {
    adObj: AdObj;
    marking: Marking;
    className?: string;
    style?: React.CSSProperties;
    white?: boolean;
    uppercase?: boolean;
    fontSize: string;
    top: string;
    right: string;
};

export default class Advertising extends React.Component<Props> {
    static defaultProps = {
        marking: 'partner',
        uppercase: true,
        fontSize: '12px',
        top: '2px',
        right: '3px',
    };
    button: TransparencyButton | null | undefined;
    element: HTMLElement | null | undefined;
    componentDidMount() {
        if (this.element) {
            const clickEventListener = (event: MouseEvent) => {
                event.preventDefault();
                event.stopPropagation();
                if (this.button) {
                    this.button.click();
                }
                return false;
            };

            this.element.addEventListener('click', clickEventListener);
        }
        if (this.element) {
            const mousedownEventListener = (event: MouseEvent) => {
                event.preventDefault();
                return false;
            };
            this.element.addEventListener('mousedown', mousedownEventListener);
        }
    }

    render() {
        const {
            adObj,
            marking,
            className,
            style,
            white,
            uppercase,
            fontSize,
            top,
            right,
        } = this.props;

        let text;
        switch (marking) {
            case 'sponsor':
                text = 'Annonse';
                break;
            case 'partner':
                text = 'Annonsørinnhold';
                break;
            default:
                text = 'Annonsørinnhold';
                break;
        }

        return (
            <div
                className={className}
                style={style}
                ref={(element) => (this.element = element)}
            >
                <span
                    style={{
                        textTransform: uppercase ? 'uppercase' : 'none',
                        fontSize: fontSize,
                        fontWeight: 'bold',
                        fontStyle: 'normal',
                        fontStretch: 'normal',
                        lineHeight: '1.33',
                        letterSpacing: 'normal',
                        color: white ? '#ffffff' : '#767676',
                    }}
                >
                    {text}
                </span>
                <TransparencyButton
                    adObj={adObj}
                    style={{
                        width: '25px',
                        height: '25px',
                        position: 'absolute',
                        opacity: white ? 1 : 0.6,
                        right: right,
                        top: top,
                        zIndex: 1,
                        filter: white ? 'brightness(0) invert(1)' : '',
                    }}
                    // white={white}
                    ref={(button) => (this.button = button)}
                />
            </div>
        );
    }
}
